import { type CSSProperties, type FC } from 'react';
import type { AlertTemplateProps } from '../Alert/types';
import InfoIcon from './icons/InfoIcon';
import SuccessIcon from './icons/SuccessIcon';
import ErrorIcon from './icons/ErrorIcon';
import CloseIcon from './icons/CloseIcon';

const alertStyle: CSSProperties = {
  backgroundColor: '#151515',
  color: 'white',
  padding: '10px',
  textTransform: 'uppercase',
  borderRadius: '3px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  boxShadow: '0px 2px 2px 2px rgba(0, 0, 0, 0.03)',
  width: '300px',
  boxSizing: 'border-box',
  zIndex: '9999',
};

const buttonStyle: CSSProperties = {
  marginLeft: '20px',
  border: 'none',
  backgroundColor: 'transparent',
  cursor: 'pointer',
};

const AlertTemplate: FC<AlertTemplateProps> = ({
  message,
  options = { type: 'info' },
  close,
  style,
}) => (
  <div className="font-sans" style={{ ...alertStyle, ...style }}>
    {/* Icons based on alert type */}
    {options.type === 'info' && <InfoIcon />}
    {options.type === 'success' && <SuccessIcon />}
    {options.type === 'error' && <ErrorIcon />}
    <span style={{ flex: 2 }}>{message}</span>
    <button type='button' onClick={close} style={buttonStyle}>
      <CloseIcon />
    </button>
  </div>
);

export { AlertTemplate };
